/**
 * Validates if a string contains characters that are not supported in Linux and LDAP systems.
 * 
 * Linux typically doesn't support certain characters in filenames and usernames.
 * LDAP has restrictions on characters for Distinguished Names (DNs) and other attributes.
 * 
 * @param str - The string to validate
 * @returns An object with isValid flag and unsupportedChars array if any found
 */
export function validateLegalString(str: string): { isValid: boolean; unsupportedChars?: string[] } {
    if (!str) {
        return { isValid: true };
    }

    // Characters not supported in Linux filenames and LDAP
    const unsupportedCharsRegex = /[\/\0<>:"|?*\\=,+#;\s]/g;
    
    // Find all unsupported characters
    const matches = str.match(unsupportedCharsRegex);
    
    if (matches) {
        // Remove duplicates from matches
        const uniqueUnsupportedChars = [...new Set(matches)];
        return {
            isValid: false,
            unsupportedChars: uniqueUnsupportedChars
        };
    }
    
    return { isValid: true };
}

/**
 * Returns a human-readable description of characters not allowed in Linux and LDAP.
 * Useful for error messages.
 * 
 * @returns A string describing the unsupported characters
 */
export function getUnsupportedCharsDescription(): string {
    return "The following characters are not supported: / \\ < > : \" | ? * = , + # ; and spaces.";
}